<!--Instructions-->
<div class="ItemBorder">
	<div style="text-align: center">
		<h4>Instructions</h4>
	</div>

	<div>
		<ul>
			<li>Select a format (CSV or Tab-Delimited Text file)</li>
			<li>Upload File</li>
			<li>Choose what each column represents</li>
			<li>
				You'll need <span class="HighlightVar">Student ID</span>, <span class="HighlightVar">Date</span>, and whatever you want to change (Status,
				Excuse, Entry Time, etc.)
			</li>
			<li>
				Note: For stauts please put <span class="HighlightVar">P</span> for Present and On-Time, <span class="HighlightVar">T</span> for Tardy, and
				<span class="HighlightVar">A</span> for Absent
			</li>
			<li>Hit finish and the file will be compared to what is currently on record</li>
			<li>You will be able to view and confirm your changes before submitting them</li>
		</ul>
	</div>

	<!--Options-->
	<div class="OptionGrid2Col">
		<label>Format:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="FormatOptionID"
			[(ngModel)]="FormatOptionID"
			(ngModelChange)="onFormatOptionIDChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFormatOption" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Skip First Line:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SkipFirstLineID"
			[(ngModel)]="SkipFirstLineID"
			(ngModelChange)="onSkipFirstLineIDChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSkipFirstLine" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>
	</div>

	<div class="OptionGrid2Col">
		<input id="ImportInput" name="ImportInput" type="file" style="display: none" (change)="onFileToImportChange($event)" />
		<label class="InfoText">{{ FileName }}</label>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUploadStart()">Select a File</button>
	</div>
</div>

<!--Preview-->
<div>
	<div *ngIf="FileData == null" class="ItemBorder TopMargin" style="text-align: center">
		<label>- Select a File -</label>
	</div>

	<div *ngIf="FileData != null" class="ItemBorder TopMargin">
		<h4 style="text-align: center">Preview:</h4>
		<p-table
			#mydt
			[value]="lstTable"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<tr>
					<th *ngFor="let col of lstCols; let i = index">
						<select class="form-control" [(ngModel)]="OptArray[i]">
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstRequiredColumns" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>
					</th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-TableVal>
				<tr>
					<td *ngFor="let o of lstCols; let i = index" style="font-weight: bold">
						{{ TableVal[i] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true || ReadyToImport == false" class="btn btn-primary" (click)="onImport()">Finish</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>
